import { APISession } from './session'
import { LLMServiceType } from './llm'

export interface PromptServiceConfig {
  Text: string | null
  ServiceType: LLMServiceType
}

export interface PromptConfig {
  LegislativeReview?: PromptServiceConfig | null
  Refinement?: PromptServiceConfig | null
  Opposition?: PromptServiceConfig | null
  Support?: PromptServiceConfig | null
  ShouldMonitor?: PromptServiceConfig | null
}

export interface TestBill {
  SessionCode: string
  BillNumber: string
}

export interface AIMonitorConfig {
  TestMode: boolean
  TestBills: TestBill[]
  ProductionEnabled: boolean
  Thresholds: {
    overall: number
    direct_umcp: number
    indirect_umcp: number
    direct_higher_ed: number
    indirect_higher_ed: number
  }
  CostControl: 'full_text' | 'synopsis'
  PromptText?: string
}

export const defaultMonitorConfig: AIMonitorConfig = {
  TestMode: false,
  TestBills: [],
  ProductionEnabled: false,
  Thresholds: {
    overall: 8,
    direct_umcp: 8,
    indirect_umcp: 8,
    direct_higher_ed: 8,
    indirect_higher_ed: 8
  },
  CostControl: 'synopsis'
}

export interface Config {
  PK: string
  SK: string
  ActiveSession: APISession
  EnableSyncJob?: boolean
  Prompts?: PromptConfig
  AIMonitor?: AIMonitorConfig
}